interface Props {
  className?: string
  icon?: string
  text?: string
  onClick: () => void
  color?: string
  disabled?: boolean
}

export function Button({ className, icon, text, onClick, color, disabled }: Props) {
  const _class = `${className} ${color ?? ''}`
  return (
    <button onClick={onClick} className={_class} disabled={disabled}>
      {!!icon && <i className={icon}></i>}
      {!!text && text}
    </button>
  )
}
